import {TrackingV2GetOrderQuery} from '@data/__generated__/types.main'

import {TrackingStatus} from '../hooks/useStatus'

export default function isScheduledAndPending(
  status: TrackingStatus,
  order: TrackingV2GetOrderQuery['order']
) {
  return status === 'confirmation' && order.isScheduled
}
